import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Button, Input, Dimmer, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import ConfirmationModal from './modal/confirmation';
import Detail from './detail';


const INITIAL_STATE = {
  'showTable': false,
  'orderFilter': '',
};

class QualityControlInvoicing extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.QualityControlInvoicing,
        scopes.Create
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  handleClearClick = () => {
    this.setState(INITIAL_STATE);
  }

  handleSearchClick = () => {
    this.setState({'showTable': true});

    const {orderFilter} = this.state;
    this.props.fetchQualityControlInvoicing(orderFilter);
  }

  getInvoicingType = () => {
    const {orders} = this.props;
    return orders.every((x) => x.anticipatedInvoice === 'S') ? 'ANTICIPADA' : 'NORMAL';
  };

  handleInvoiceClick = () => {
    const {orderFilter} = this.state;
    this.props.createQualityControlInvoice(orderFilter);
  }

  onChangeValues = (value, field) => {
    const {showTable} = this.state;
    const newState = {
      [field]: value.toUpperCase(),
    };
    if (showTable) {
      newState.showTable = false;
    }
    this.setState(newState);
  }

  renderFiltersSection = () => {
    const {loading, processingInvoice, dealerInfo} = this.props;
    const {showTable, orderFilter} = this.state;

    return (
      <Grid>
        <Grid.Row textAlign="left">
          <Grid.Column width={2}>
            <h4>No Orden:</h4>
          </Grid.Column>
          <Grid.Column width={2}>
            <Input
              value={orderFilter}
              disabled={loading || processingInvoice}
              onChange={(e, {value}) =>
                this.onChangeValues(value, 'orderFilter')
              }
              placeholder="Order"
            />
          </Grid.Column>
          <Grid.Column width={2}>
            {showTable && <h4 style={{'textAlign': 'right'}}>Facturar a:</h4>}
          </Grid.Column>
          <Grid.Column width={3}>{showTable && dealerInfo.name}</Grid.Column>
          <Grid.Column width={2}>
            {showTable && <h4>Tipo de Facturación:</h4>}
          </Grid.Column>
          <Grid.Column width={2}>
            {showTable && this.getInvoicingType()}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    const {loading, processingInvoice, orders, dealerInfo, agencies} =
      this.props;
    const {showTable, orderFilter} = this.state;

    return (
      <div className="accessories-invoicing">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Facturación de Control de Calidad</h2>
              <div className="title-bar-actions">
                <Button
                  secondary
                  disabled={loading || processingInvoice}
                  onClick={this.handleClearClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  disabled={
                    !orderFilter || loading || processingInvoice
                  }
                  onClick={this.handleSearchClick}
                >
                  Buscar
                </Button>
                <ConfirmationModal
                  dealerInfo={dealerInfo}
                  agencies={agencies}
                  order={orderFilter}
                  disabled={!showTable || loading || processingInvoice}
                  onInvoiceClick={this.handleInvoiceClick}
                />
              </div>
            </div>
            <div className="filters-section">{this.renderFiltersSection()}</div>
          </div>
        </Card>

        {showTable && <Detail loading={loading} orders={orders} />}

        {processingInvoice && (
          <Dimmer active inverted>
            <Loader inverted content="Procesando..." />
          </Dimmer>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.qualityControlInvoicing.loading,
    'orders': state.qualityControlInvoicing.orders,
    'agencies': state.qualityControlInvoicing.agencies,
    'dealerInfo': state.qualityControlInvoicing.dealerInfo,
    'processingInvoice': state.qualityControlInvoicing.invoicing,
    'permissions': state.session.permissions,
  };
};

const {fetchQualityControlInvoicing, createQualityControlInvoice, navigateTo} =
  Actions;

export default connect(mapStateToProps, {
  fetchQualityControlInvoicing,
  createQualityControlInvoice,
  navigateTo,
})(QualityControlInvoicing);
